module.exports = __webpack_public_path__ + "static/media/logo_zz.a0ecf0ea.png";